<template>
  <!-- 会议室列表 -->
  <div class="list-layout-box" :class="[{'permit-nav':mobNavShow}]">
    <div class="top-fix-container">
      <back-route-hdr :back-mode="'static'"></back-route-hdr>
      <van-search v-model="searchText" show-action :placeholder="`搜索${roomTitle}`" class="bord-btm">
        <template #action></template>
      </van-search>
      <room-tree-filter :filter-date="true" :filter-doc="filterDoc"
                        @handle-filter="handleFilter"></room-tree-filter>
      <div class="pad-lft pad-ver-10 bg-grad">
        <van-tag round class="mar-rgt-5">不可约</van-tag>
        <van-tag round type="warning" class="mar-rgt-5">已预约</van-tag>
        <van-tag round type="success">可预约</van-tag>
      </div>
    </div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div v-if="refreshTime && !roomList.length && finished">
        <empty-notice :image="'search'" :desc="`暂无${roomTitle}`"></empty-notice>
      </div>

      <div v-else class="custom-steps ctn-mar-lg">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <van-cell-group v-for="(roomInfo, idx) in roomCells" :key="idx" :class="roomInfo.style"
                          :title="roomInfo.location" :name="idx">
            <van-cell v-for="room in roomInfo.list" :key="room.roomId"
                      @click="handleDetail(room)">
              <template #title>
                <div class="mar-btm-5 text-ellipsis">
                  <span class="text-nowrap">{{room.newName || room.name}}</span>
                  <!--<van-tag class="mar-lft-5" v-show="room.isOccupied" type="danger" plain round>有人</van-tag>-->
                  <span v-show="!room.isDisabled" class="pull-right detail-title text-sm">点击预约&nbsp;
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </span>
                </div>
              </template>
              <template #label>
                <div v-show="room.showLct" class="text-sm mar-btm-5">
                  <span>{{room.locationInfo}}</span>
                </div>
                <div class="text-sm mar-btm-5 flex flex-start flex-align-center">
                  <span class="mar-rgt-10 flex flex-align-center">
                    <i class="iconfont icon-qunzu text-sm mar-rgt-5"></i>{{room.capacity}}人</span>
                  <span v-show="room.roomTypeStr" class="mar-rgt-10">
                    <i class="iconfont icon-jibie text-sm mar-rgt-5"></i>{{room.roomTypeStr}}</span>
                  <span v-show="room.labelStr" class="mar-rgt-10">
                    <i class="iconfont icon-biaoqian text-sm mar-rgt-5"></i>{{room.labelStr}}</span>
                  <span v-show="room.deviceExceptionTip" class="mar-rgt-10 text-danger">
                    <i class="iconfont icon-xinhao text-sm mar-rgt-5 text-danger"></i>{{room.deviceExceptionTip}}</span>
                </div>
                <div class="van-steps van-steps--horizontal">
                  <div class="van-steps__items">
                    <div v-for="ele in formatStepOptions(room)"
                         :key="ele.slot" :class="ele.slotClass"
                         class="van-hairline van-step van-step--horizontal">
                      <div class="van-step__title">{{ele.title}}</div>
                      <div class="van-step__circle-container">
                        <i v-show="ele.show" class="van-step__circle"></i></div>
                      <div class="van-step__line"></div>
                    </div>
                  </div>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </van-list>
      </div>

    </van-pull-refresh>

  </div>
</template>

<script>
  import {commonConfig} from "../../../../config/common";
  import RoomTreeFilter from './RoomTreeFilter'
  import {meetingRoom} from "../../../../server";
  import routerMeta from "../../router/routerMeta";
  import {
    getReservedSlotsByTime,
    getSlotByDate,
    getTimeBySlot,
    refreshDebounce,
    checkShowPermit,
    savePagePosition,
    removePagePosition
  } from "../../../../tools/utils";

  export default {
    components: {RoomTreeFilter},
    data() {
      return {
        searchText: "",
        roomList: [],
        frequentRooms: [],
        filterDoc: {
          date: (new Date()).valueOf()
        },
        refreshing: false,
        refreshTime: "",
        pageInfo: {
          pageSize: 10,
          pageNum: 1,
          pages: 1,
        },
        finished: false,
        loading: false,
        fromUserPanel: false,
      }
    },
    computed: {
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
      // 常用会议室
      frequentRoomCell() {
        if (this.frequentRooms.length) {
          return [{
            location: `常用${this.roomTitle}`,
            style: "frequent-room",
            list: this.frequentRooms.map(e => {
              this.formatRoomDoc(e);
              e.showLct = true;
              return e
            })
          }]
        }
        return []
      },
      roomCells() {
        const obj = {};
        // console.log('roomCells', this.roomList);
        this.roomList.forEach(r => {
          this.formatRoomDoc(r);
          if (obj[r.locationInfo]) {
            obj[r.locationInfo].push(r)
          } else {
            obj[r.locationInfo] = [r]
          }
        });
        return this.frequentRoomCell.concat(Object.keys(obj).map(k => ({
          location: k,
          list: obj[k]
        })))
      },
      basicStepOptions() {
        const {timelineStartAt, timelineEndAt} = this.$store.state.sysConfig
        // 数字
        const {
          min,
          max
        } = timelineStartAt ? this.meetingRoomTime(timelineStartAt, timelineEndAt) : commonConfig.stepSlots;

        const diffDay = moment(this.filterDoc.date).startOf('d').diff(moment().startOf('day'), 'd');
        let minStartSlot = min;
        if (diffDay < 0) {
          minStartSlot = max
        } else if (diffDay === 0) {
          minStartSlot = getSlotByDate(new Date());
        }
        const opts = [];
        let idx = min;
        let timeInterval = (max / 2) - (min / 2)
        // let num = timeInterval >= 20 ? 7 : timeInterval >= 17 ? 6 : 5// 判断时间是不是过长,避免时间过多样式显示不全

        let num = 1;
        if (timeInterval >= 20) {
          num = 8;
        } else if (timeInterval >= 17) {
          num = 6;
        } else if (timeInterval >= 12) {
          num = 5;
        } else if (timeInterval >= 10) {
          num = 4;
        } else if (timeInterval >= 7) {
          num = 3;
        } else if (timeInterval >= 3) {
          num = 2
        }

        while (idx <= max) {
          const show = min === idx || (idx - min) % num === 0 || max === idx && ((idx - min) % num >= 6 && num === 8 || (idx - min) % num >= 4 && num <= 6) || max - min < 7;
          opts.push({
            title: show ? getTimeBySlot(idx) : "",
            show: show,
            slot: idx,
            slotClass: idx >= minStartSlot ? "slot-free" : ""
          });
          idx++
        }
        opts.push({
          title: '',
          show: true,
          slot: '',
          slotClass: max >= minStartSlot ? "slot-free" : ""
        });

        return opts
      },
      comFilterData() {
        return {
          ...(this.filterDoc || {}),
          // date: this.todayVal,
          textField: this.searchText
        }
      },
      mobNavShow() {
        const permissionList = this.$store.state.permissionList || [];
        return checkShowPermit(permissionList, this.permitsMap.mobNav)
      }
    },
    watch: {
      // 响应搜索
      searchText(val) {
        // console.log(val)
        this.initRoomList()
      },
    },
    created() {
      const roomFilter = this.$store.state.roomFilter;
      if (roomFilter) {
        this.filterDoc = roomFilter;
        this.$store.commit('setRoomFilter', null);  // 清除
      }
      if (this.$route.name === routerMeta.selfFrequentRoom.name) {
        this.finished = true;
        this.fromUserPanel = true;
      }
      this.getFrequentRoom();
    },
    methods: {
      // 时间转换数字 例 9:00 ： 18
      meetingRoomTime(startTime, endTime) {
        let start = startTime.split(":");
        let end = endTime.split(":");
        let stepSlots = {}
        stepSlots.min = start[1] == '30' ? (Number(start[0]) + 0.5) * 2 : (Number(start[0])) * 2
        stepSlots.max = end[1] == '30' ? (Number(end[0]) + 0.5) * 2 : (Number(end[0])) * 2
        return stepSlots
      },
      onRefresh() {
        // console.log(this.refreshing);
        // 刷新防抖动
        if (this.refreshTime && refreshDebounce(this.refreshTime)) {
          this.refreshing = false;
          vtToast('刷新成功');
          return
        }
        this.initRoomList()
      },
      onLoad() {
        this.getRoomList(this.pageInfo.pageNum++)
      },
      initRoomList() {
        this.pageInfo.pageNum = 1;
        this.roomList = [];
        this.getFrequentRoom();
        if (this.fromUserPanel) return;
        this.finished = false;
        this.onLoad()
      },
      // 常用会议室，单独查找
      getFrequentRoom() {
        meetingRoom.frequentRoom(this, {
          queryFilter: this.comFilterData,
          mid: this.$route.params.mid || "",
        }).then(({searchFrequentRoom: data = {}}) => {
          if (this.fromUserPanel && this.refreshing) {
            this.refreshing = false;
            vtToast('刷新成功');
          }
          this.frequentRooms = (data.roomEdges || []).map(e => ({
            ...e.room,
            locationInfo: (e.room.locationList || []).map(e => e.name).join('-')
          }))
        }).catch(err => {
          if (this.fromUserPanel) {
            this.refreshing = false;
          }
        });
      },
      // 获取房间列表
      getRoomList(pageNum = 1) {
        !this.refreshing && !this.loading && UILoader.load();
        // 分页查找
        meetingRoom.queryList(this, {
          queryFilter: {
            ...this.comFilterData,
            pageNum,
            pageSize: this.pageInfo.pageSize,
          },
          queryAll: true
        }).then(({searchRoom: data = {}}) => {
          // 数据懒加载
          this.loading = false;
          UILoader.unload();
          const {roomEdges, pageInfo} = data;
          this.roomList = this.roomList.concat((roomEdges || []).map(e => ({
            ...e.room,
            locationInfo: (e.room.locationList || []).map(e => e.name).join('-'),
          })));
          if (this.refreshing) {
            this.refreshing = false;
            vtToast('刷新成功');
          }
          this.refreshTime = new Date();
          this.pageInfo.pages = Math.ceil((pageInfo.total || 0) / this.pageInfo.pageSize);
          if (!pageInfo.total || pageNum >= this.pageInfo.pages) {
            this.finished = true
          }
        }).catch(err => {
          UILoader.unload();
          // console.log(err);
          this.refreshing = false;
          this.loading = false;
          this.finished = true;
          vtToast(err.message)
        });
      },
      formatRoomDoc(room) {
        const {roomTypes = [], roomLabels = []} = this.$store.state.sysConfig;
        let roomTypeStr = "";
        const {roomTypes: types, labels} = room;
        if (types && types.length) {
          roomTypeStr = roomTypes.filter(e => types.includes(e.value)).map(e => e.label).join('、')
        }
        const labelList = [];
        if (labels && labels.length) {
          roomLabels.forEach(lb => {
            const values = lb.values.filter(e => labels.includes(e.value));
            values.length && labelList.push(values.map(e => e.label).join('、'))
          })
        }
        room.roomTypeStr = roomTypeStr;
        room.labelStr = labelList.join('、');
      },
      // 时间节点格式化
      formatStepOptions({available, isDisabled}) {
        const reservedSlots = getReservedSlotsByTime(available || {});
        // 判断是否需要进行处理
        if (!reservedSlots.length) {
          if (isDisabled) {
            return this.basicStepOptions.map(opt => ({...opt, slotClass: ""}))
          }
          return this.basicStepOptions;
        }
        return this.basicStepOptions.map(opt => {
          if (reservedSlots.includes(opt.slot)) {
            return {
              ...opt,
              slotClass: 'slot-occupied'
            }
          }
          if (isDisabled) {
            return {...opt, slotClass: ""}
          }
          return opt
        })
      },
      // 查询
      handleFilter(data) {
        this.filterDoc = data;
        this.refreshTime = "";
        this.initRoomList()
      },
      handleDetail(doc) {
        savePagePosition('roomList')
        this.filterDoc && this.$store.commit('setRoomFilter', this.filterDoc);
        this.$router.push({name: routerMeta.roomDetail.name, params: {rid: doc.roomId}})
      },
    },
    activated() {
      window.scroll(0, localStorage.getItem("roomList"))
      removePagePosition()
    },
    beforeRouteLeave(to, from, next) {
      // 只有在跳转到详情页时才需要保持当前页面
      from.meta.keepAlive = to.name === routerMeta.roomDetail.name;
      next();
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .van-dropdown-item__content {
    max-height: 88%;
  }

  .custom-steps .van-steps--horizontal {
    padding-right: 1px;
  }

  .custom-steps .van-step--horizontal:nth-last-child(2) .van-step__title {
    margin-left: -3px
  }
</style>
